import {modalInteraction} from '../events'
import withSnowplowLifecycle from './withSnowplowLifecycle'

const withModalInteraction = (WrappedComponent, options = null) => withSnowplowLifecycle(WrappedComponent, modalInteraction, options)

export default withModalInteraction
